<template>
	<section class="no-marginbottom">
		<h2>{{ headline }}</h2>
	</section>

	<swiper
		v-if="isMobile"
		:direction="'horizontal'"
		:loop="false"
		:spaceBetween="20"
		:slides-per-view="data.length > 1 ? 1.25 : 1"
		:centeredSlides="false"
		:freeMode="{ enabled: false, sticky: false }"
		:mousewheel="true"
		:class="'slider--boxes'"
	>
		<swiper-slide v-for="item in data" :key="item.hid">
			<BoxDecision :decision="item" :caseTitle="caseTitle" :preVoteEndDate="preVoteEndDate" :voteEndDate="voteEndDate" />
		</swiper-slide>
	</swiper>
	<section v-else>
		<DecisionsTable
			:tableData="data"
			:totalCount="data.length"
			:caseTitle="caseTitle"
			:preVoteEndDate="preVoteEndDate"
			:voteEndDate="voteEndDate"
			@loadNextPage="null"
		/>
	</section>
</template>

<script lang="ts">
import { defineComponent, ref, computed, PropType } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { useStore } from '@/store';
import DecisionsTable from '@/components/tables/DecisionsTable.vue';
import BoxDecision from '@/components/boxes/BoxDecision.vue';
import { DecisionResponse, SendCaseType } from '../../types/types';

export default defineComponent({
	name: 'SectionDecision',
	data() {
		return {};
	},
	props: {
		headline: {
			type: String,
			required: true,
		},
		data: {
			type: Array as PropType<DecisionResponse[]>,
			required: true,
		},
		caseTitle: {
			type: String,
			default: '',
		},
		preVoteEndDate: {
			type: String,
			default: '',
		},
		voteEndDate: {
			type: String,
			default: '',
		},
	},
	components: {
		Swiper,
		SwiperSlide,
		DecisionsTable,
		BoxDecision,
	},
	setup() {
		const store = useStore();
		const isMobile = computed(() => store.state.isMobile);

		return {
			store,
			isMobile,
		};
	},
});
</script>
